
import {
  newsPosts,
  NewsPostsPaginatorQuery,
} from '@/queries/news/newsPosts.gql'
export default {
  name: 'NewsIndex',
  navigation: {
    disableTransparency: true,
  },
  async asyncData({ $config, $queryPage }) {
    try {
      const { data } = await $queryPage(newsPosts, {
        page: 1,
        domainId: $config.domainId,
        postsLimit: 6,
      })

      const newsPostsData = data?.newsPosts?.data

      return {
        newsPosts: newsPostsData.map((item, index) => {
          return {
            ...item,
            chunk_id: index,
          }
        }),

        showMoreEnabled: data.newsPosts.paginatorInfo.hasMorePages,
      }
    } catch (ex) {
      console.error('news/index asyncData', ex)
    }
  },
  data() {
    return {
      loading: false,
      page: 1,
      newsPosts: [],
      archiveInitialAmount: 4,
      archiveIncreaseAmount: 2,
      showMoreEnabled: false,
    }
  },
  computed: {
    toTopPrimary() {
      return this?.newsPosts?.[0] || {}
    },
    toTopSecondary() {
      const array = []
      if (this?.newsPosts?.[1]) {
        array.push(this.newsPosts[1])
      }
      if (this?.newsPosts?.[2]) {
        array.push(this.newsPosts[2])
      }
      return array
    },
    bottomPosts() {
      if (this?.newsPosts?.length <= 3) return []
      return this?.newsPosts?.slice(3)
    },
    listTitle() {
      let title = 'list_headline'
      if (this.$config?.domain?.includes('ems')) {
        title = 'continue.ems'
      }
      return this.$t(`front.news.${title}`)
    },
  },
  methods: {
    async loadMore() {
      if (!this.showMoreEnabled || this.loading) return false
      this.loading = true
      this.page++
      try {
        const response = await this.$gqlQuery({
          query: NewsPostsPaginatorQuery,
          variables: {
            page: this.page,
            domainId: this.$config.domainId,
            postsLimit: 6,
            languageCode: this.$i18n.locale,
          },
        })
        const newNewsPosts = response.data.newsPosts.data.map((item, index) => {
          return {
            ...item,
            chunk_id: index,
          }
        })
        const hasMore = response.data.newsPosts.paginatorInfo.hasMorePages
        this.showMoreEnabled = hasMore
        this.newsPosts = [...this.newsPosts, ...newNewsPosts]
        this.loading = false
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      } catch (ex) {
        this.loading = false
      }
    },
  },
}
